import {observable, action} from 'mobx'
import {timeFormat} from 'd3-time-format'
import {notification} from 'antd'

export class Debug {
  @observable startDate = timeFormat('%Y-%m-%d')(new Date())
  @observable running = false
  @observable id
  @observable message

  constructor(rootStore, api) {
    this.root = rootStore
    this.api = api
  }

  @action setId(id) {
    this.id = id
  }

  @action changeDate(date) {
    if (date) {
      this.startDate = date
    } else {
      this.startDate = timeFormat('%Y-%m-%d')(new Date())
    }
  }

  @action async run() {
    try {
      const body = {start_date: this.startDate}
      const url = `sys/paper-trading-sessions/${this.id}/simulation/start`
      await this.api.request(url, 'post', body)
      this.running = true
      this.checkStatus()
    } catch (e) {
      notification['error']({
        message: 'Failed to run paper trading simulation',
        description: e.message || 'Unknown error'
      })
    }
  }

  @action async checkStatus() {
    try {
      const url = `sys/paper-trading-sessions/${this.id}/simulation/status`
      const {status, message} = await this.api.request(url, 'get')
      if (status !== 'completed') {
        this.running = true
        setTimeout(() => this.checkStatus(), 500)
      } else {
        this.running = false
      }
      this.message = message
    } catch(e) {
      this.running = false
      notification['error']({
        message: 'Failed to get paper trading simulation status',
        description: e.message || 'Unknown error'
      })
    }
  }
}
